<div class="container">
    <div class="header">
        <div class="header-top">
            <div class="logo-section">
                <div class="logo">A</div>
                <div>
                    <h1>Altair AD Miner</h1>
                    <div class="header-subtitle">Dashboard Completo de Análisis de Active Directory</div>
                </div>
            </div>
        </div>

        <div class="client-info">
            <div class="info-item">
                <span class="info-label">Cliente:</span>
                <span class="info-value">fcar</span>
            </div>
            <div class="info-item">
                <span class="info-label">Fecha de Análisis:</span>
                <span class="info-value">07/10/2025</span>
            </div>
            <div class="info-item">
                <span class="info-label">Dominio:</span>
                <span class="info-value">fcar.local</span>
            </div>
            <div class="info-item">
                <span class="info-label">Tipo de Análisis:</span>
                <span class="info-value">On-Premise</span>
            </div>
        </div>
    </div>

    <mat-tab-group class="nav-tabs" dynamicHeight>
        <mat-tab label="Vista General">
            <div class="main-grid">
                <div class="risk-rating-card">
                    <h5 class="risk-rating-title">🛡️ Calificación de Riesgo On-Premise</h5>
                    <div class="risk-level">CRÍTICO</div>
                    <div class="risk-breakdown">
                        <h6>Desglose de Indicadores de Exposición</h6>

                        <div class="risk-item immediate">
                            <div class="risk-item-label"><span>⚠️</span><span>Riesgo Inmediato</span></div>
                            <span class="risk-badge immediate">{{ immediateCount }}</span>
                        </div>

                        <div class="risk-item potential">
                            <div class="risk-item-label"><span>🔶</span><span>Riesgo Potencial</span></div>
                            <span class="risk-badge potential">{{ potentialCount }}</span>
                        </div>

                        <div class="risk-item minor">
                            <div class="risk-item-label"><span>🔸</span><span>Riesgo Menor</span></div>
                            <span class="risk-badge minor">{{ minorCount }}</span>
                        </div>

                        <div class="risk-item handled">
                            <div class="risk-item-label"><span>✅</span><span>Riesgo Controlado</span></div>
                            <span class="risk-badge handled">{{ handledCount }}</span>
                        </div>
                    </div>
                </div>

                <div class="dashboard-card">
                    <h2 class="dashboard-title">Vista General de Seguridad</h2>

                    <div class="charts-container">
                        <div class="chart-section">
                            <h3 class="chart-title">Distribución de Riesgos por Severidad</h3>
                            <div class="chart-container">
                                <apx-chart [series]="riskChartOptions.series!" [chart]="riskChartOptions.chart!"
                                    [labels]="riskChartOptions.labels!" [title]="riskChartOptions.title!"
                                    [fill]="riskChartOptions.fill!" [yaxis]="riskChartOptions.yaxis!"
                                    [tooltip]="riskChartOptions.tooltip!" [stroke]="riskChartOptions.stroke!"
                                    [colors]="riskChartOptions.colors!" [legend]="riskChartOptions.legend!"
                                    [plotOptions]="riskChartOptions.plotOptions!"></apx-chart>
                            </div>
                        </div>

                        <div class="chart-section">
                            <h3 class="chart-title">Estado General del Dominio</h3>
                            <div class="chart-container">
                                <!--apx-chart [series]="domainChartOptions.series!" [chart]="domainChartOptions.chart!"
                                        [dataLabels]="domainChartOptions.dataLabels!"
                                        [plotOptions]="domainChartOptions.plotOptions!" [yaxis]="domainChartOptions.yaxis!"
                                        [xaxis]="domainChartOptions.xaxis!" [legend]="domainChartOptions.legend!"
                                        [colors]="domainChartOptions.colors!" [grid]="domainChartOptions.grid!"></!--apx-chart-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="issues-grid">
                <div class="issues-category critical">
                    <div class="issue-item"
                        (click)="showIssueDetail('critical', 'Rutas de ataque peligrosas', '8 rutas identificadas que permiten escalación de privilegios desde usuarios normales hasta administradores de dominio.')">
                        <div class="issue-name">Rutas de ataque peligrosas</div>
                        <div class="issue-count">8</div>
                    </div>
                </div>
            </div>

            <div class="stats-section">
                <h2 class="stats-title">Estadísticas del Dominio</h2>
                <div class="stats-grid">
                    <div class="stat-card">
                        <div class="stat-number">{{ domainStats.nb_domains }}</div>
                        <div class="stat-label">Dominio ({{ domainStats.nb_domains }} recopilado)</div>
                        <!--button class="stat-detail-btn" (click)="showStatDetail('domain')">Ver Detalles</!--button-->
                    </div>
                    <div class="stat-card">
                        <div class="stat-number">{{ domainStats.nb_users }}</div>
                        <div class="stat-label">Usuarios</div>
                        <!--button class="stat-detail-btn" (click)="showSection('users')">Ver Detalles</!--button-->
                    </div>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Usuarios">
            <div id="users">
                <div class="data-table">
                    <h2 class="table-title">👥 Usuarios del Dominio</h2>
                    <div class="table-container">
                        <table class="custom-table">
                            <thead></thead>
                            <tbody>
                                <tr *ngFor="let user of usersData">
                                    <td>{{ user.name }}</td>
                                    <td><span class="status-badge"
                                            [ngClass]="user.status === 'Activo' ? 'status-active' : 'status-inactive'">{{
                                            user.status }}</span></td>
                                    <td>{{ user.lastAccess }}</td>
                                    <td>{{ user.privileges }}</td>
                                    <td>{{ user.groups }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Grupos">
            <div id="groups">
            </div>
        </mat-tab>
        <mat-tab label="Computadoras">
            <div id="computers">
            </div>
        </mat-tab>
        <mat-tab label="Problemas de Seguridad">
            <div id="security">
                <div class="data-table">
                    <h2 class="table-title">🔒 Problemas de Seguridad Detallados</h2>
                    <div class="table-container">
                        <table class="custom-table">
                            <thead></thead>
                            <tbody>
                                <tr *ngFor="let sec of securityData">
                                    <td>{{ sec.problem }}</td>
                                    <td><span class="status-badge" [ngClass]="getSeverityBadgeClass(sec.severity)">{{
                                            sec.severity }}</span></td>
                                    <td>{{ sec.count }}</td>
                                    <td>{{ sec.impact }}</td>
                                    <td><span class="status-badge status-warning">{{ sec.status }}</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Estadísticas Detalladas">
            <div id="statistics">
            </div>
        </mat-tab>
    </mat-tab-group>


    <div id="detailModal" class="modal" [style.display]="isModalOpen ? 'block' : 'none'" (click)="closeModal()">
        <div class="modal-content" (click)="$event.stopPropagation()">
            <div class="modal-header">
                <h2 class="modal-title">{{ modalTitle }}</h2>
                <span class="close" (click)="closeModal()">&times;</span>
            </div>
            <div class="modal-body">
                <ng-container *ngIf="modalBodyContent.description">
                    <div class="detail-item">
                        <div class="detail-label">Severidad:</div>
                        <div class="detail-value">{{ modalBodyContent.severity }}</div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-label">Descripción:</div>
                        <div class="detail-value">{{ modalBodyContent.description }}</div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-label">Recomendación:</div>
                        <div class="detail-value">{{ modalBodyContent.recommendation }}</div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-label">Impacto Potencial:</div>
                        <div class="detail-value">{{ modalBodyContent.impact }}</div>
                    </div>
                </ng-container>

                <ng-container *ngIf="!modalBodyContent.description">
                    <div class="detail-item" *ngFor="let key of objectKeys(modalBodyContent)">
                        <div class="detail-label">{{ key }}:</div>
                        <div class="detail-value">{{ modalBodyContent[key] }}</div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
